import { Autocomplete } from "@mui/lab";
import { Box, TextField } from "@mui/material";
import { FieldError } from "react-hook-form";
import { BilletStatusTag } from "../components/BilletStatusTag";

export const billetStatus = [
	{
		code: "H",
		name: "on hand",
		backgroundColor: "#C5E0B3",
		hoverColor: "#e9f3e2ff",
	},
	{
		code: "C",
		name: "to be cast SWVA",
		backgroundColor: "#eded67ff",
		hoverColor: "#f9f9b7ff",
	},
	{
		code: "O",
		name: "on order",
		backgroundColor: "#c3d3ee",
		hoverColor: "#f2f5fdff",
	},
	{
		code: "N",
		name: "need to order",
		backgroundColor: "#EDA5BF",
		hoverColor: "#f8e1eaff",
	},
];

type Props = {
	label?: string;
	value: string | null;
	readOnly?: boolean;
	onChange?: Function;
	fieldError?: FieldError | undefined;
	disabled?: boolean;
	required?: boolean;
};

export const BilletStatusSelector = ({
	label = "Billet Status",
	value,
	readOnly = false,
	onChange = () => {},
	fieldError,
	disabled = false,
	required = false,
}: Props) => {
	const selectedType =
		billetStatus.find((code) => code.code === value) || billetStatus[0];

	return (
		<Autocomplete
			id="event-type-selector"
			clearOnEscape
			autoHighlight
			disableClearable
			options={billetStatus}
			getOptionLabel={(option) => `Billets ${option.name}`}
			renderOption={(props, option) => (
				<Box
					{...props}
					component="li"
					style={{
						display: "flex",
						alignItems: "center",
					}}
				>
					<span
						style={{
							width: "25px",
							height: "25px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginRight: "8px",
							marginLeft: "8px",
						}}
					>
						<BilletStatusTag
							event={{
								Code: option.code,
								Name: option.name,
							}}
						/>
					</span>
					Billets {option.name}
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					required={required}
					label={label}
					aria-readonly={readOnly}
					fullWidth
					error={!!fieldError}
					helperText={fieldError?.message}
					margin="none"
					size="small"
					inputProps={{
						...params.inputProps,
						"data-test-id": "billet-status-selector",
					}}
					InputProps={{
						...params.InputProps,
						startAdornment: selectedType ? (
							<span
								style={{
									width: "25px",
									height: "25px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginRight: "8px",
									marginLeft: "8px",
								}}
							>
								<BilletStatusTag
									event={{
										Code: selectedType?.code ?? "",
										Name: selectedType?.name ?? "",
									}}
								/>
							</span>
						) : null,
					}}
				/>
			)}
			value={selectedType}
			onChange={(event, newValue) => {
				onChange(newValue?.code ?? null);
			}}
			disabled={disabled}
		/>
	);
};
